// extracted by mini-css-extract-plugin
export var loader = "Loader-module--loader--f4d89";
export var rotate = "Loader-module--rotate--c1bf8";